// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinOutlinedSvg from "@fishx/icons-svg/es/asn/PushpinOutlined";
import FishxIcon from '../components/FishxIcon';

var PushpinOutlined = function PushpinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinOutlinedSvg
  }));
};

PushpinOutlined.displayName = 'PushpinOutlined';
export default React.forwardRef(PushpinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PushpinOutlined.js
// module id = 3940
// module chunks = 0